import styled from 'styled-components';

import Button, { ButtonColor } from '@minecraft.button';
import Icon from '@minecraft.icon';

export const StyledButton = styled(Button)<{ color?: ButtonColor }>`
  padding: 0;
  text-align: left;
  height: auto;
  text-decoration: none;
  outline: none;
  color: ${({ theme }) => theme.colors.primary.primary};

  &:hover {
    color: ${({ theme }) => theme.colors.primary.primary};
  }
`;

export const NotesList = styled.div`
  border: 0.0625rem solid ${({ theme }) => theme.colors.primary.ltGrey1};
  padding: 0.5rem;
`;

export const Note = styled.div`
  margin-top: 1rem;
`;

export const Header = styled.div`
  font-weight: 600;
`;

export const Signature = styled.div`
  font-style: italic;
`;

export const StyledIcon = styled(Icon)`
  margin-bottom: 0.3rem;
`;
